// import { FormControl } from "@angular/forms";

// export class PasswordValidator {
//     static passordConfirm(otherPropertyKey: string) {
//   
        
//         return (fc: FormControl) => {
//             if (!fc.parent) {
//                 return;
//             }

//             const otherControl = fc.parent.get(otherPropertyKey);

//             if (!otherControl) {
//                 return;
//             }

//             const actualValue = fc.value;
//             const otherValue = otherControl.value;

//             if (actualValue !== otherValue) {
//                 return {
//                     passwordConfirm: 'Les mots de passe ne coincident pas'
//                 }
//             } else {
//                 // Si valide, permet de mettre à jour l'état de validité de l'autre control
//                 otherControl.updateValueAndValidity();
//             }

//             return null;
//         };
//     }
// }

import {ValidatorFn, AbstractControl, ValidationErrors} from '@angular/forms';

export function matchValidator(
    matchTo: string, 
    reverse?: boolean
  ): ValidatorFn {
    return (control: AbstractControl): 
    ValidationErrors | null => {
      if (control.parent && reverse) {
        const c = (control.parent?.controls as any)[matchTo] as AbstractControl;
        if (c) {
          c.updateValueAndValidity();
        }
        return null;
      }
      return !!control.parent &&
        !!control.parent.value &&
        control.value === 
        (control.parent?.controls as any)[matchTo].value
        ? null
        : { matching: true };
    };
  }